<template>
  <div>
    <Upload
      ref="uploadFileRef"
      type="drag"
      :action="actionUrl"
      :headers="uplaodHeaders"
      :format="['xlsx']"
      :on-success="successFun"
      :on-error="errorFun"
      :on-format-error="formatErrorFun"
    >
      <div style="padding: 20px 0">
        <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
        <p>Click or drag files here to upload [.xlsx]</p>
      </div>
    </Upload>
  </div>
</template>
<script>
export default {
  data() {
    return {
      uplaodHeaders: {
        Authorization: "",
        ProjectId: "",
      },
    };
  },
  props: {
    actionUrl: String,
  },
  methods: {
    init() {
      this.uplaodHeaders.Authorization = `Bearer ${this.$route.query.token}`;
      this.uplaodHeaders.ProjectId = this.$route.query.projectId;
    },
    successFun(response) {
      // console.log(response, file, fileList);
      this.$refs.uploadFileRef.clearFiles();
      if (response.message === "Succeed") {
        if (response.data.successCount === response.data.total) {
          this.$Notice.success({
            title: "Reminder",
            desc: "Successfully added assets!",
            duration: 25,
          });
          setTimeout(() => {
            this.$emit("uploadSuccessEmit", true);
          }, 300);
        } else {
          this.$emit("uploadErrorEmit", response.data.errorDetails);
        }
      } else {
        this.$refs.uploadFileRef.clearFiles();
        this.$Notice.error({
          title: "Failed to add assets.",
          desc: response.Message,
          duration: 25,
        });
      }
    },
    errorFun(error) {
      // console.log(error, file, fileList);
      this.$Notice.error({
        title: "Failed to add assets.",
        desc: error.Message,
        duration: 25,
      });
      this.$refs.uploadFileRef.clearFiles();
    },
    formatErrorFun() {
      this.$Notice.error({
        title: "Format Error",
        desc: "Please upload xlsx file.",
        duration: 25,
      });
      this.$refs.uploadFileRef.clearFiles();
      // console.log(file, fileList);
    },
  },
  created() {
    this.init();
  },
};
</script>
